import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as moment from 'moment';
import {combineLatest, of, switchMap} from 'rxjs';
import {OrderStatus} from 'src/app/models/OrderStatus';
import {PreorderType} from 'src/app/models/PreorderType';
import {Venue} from 'src/app/models/Venue';
import {NavigationService} from 'src/app/services/navigation.service';
import {ManagerFacade} from 'src/app/store/manager/+state/manager.facade';

@Component({
	selector: 'app-manager-header',
	templateUrl: './manager-header.component.html',
	styleUrls: ['./manager-header.component.scss']
})
export class ManagerHeaderComponent implements OnInit {
	@Input() venue: Venue | null;
	@Input() showBack = false;
	@Input() showChip = false;
	@Input() showFaq = false;
	@Input() showNotification = false;
	@Input() showMessages = false;
	@Input() listenShowBack = false;
	@Output() backEvent = new EventEmitter<void>();
	filtersChips = [
		{status: null, quantity: 0, color: '#B0063E', selected: false},
		{
			status: OrderStatus.IN_PREPARATION,
			quantity: 0,
			color: '#FD5E00',
			selected: false
		},
		{status: OrderStatus.READY, quantity: 0, color: '#34A853', selected: false},
		{status: OrderStatus.DONE, quantity: 0, color: '#A9A9A9', selected: false}
	];
	filtersChips$ = combineLatest([
		this.managerFacade.orders$,
		this.managerFacade.orderStatusFiler$
	]).pipe(
		switchMap(([orders, status]) => {
			const today = moment().startOf('day'); // Start of today's day (midnight)

			orders = orders.filter(it => {
				const isFoodspot = it?.preorder?.type === PreorderType.FOOD_SPOT;
				if (it.asap) {
					return true;
				}
				return moment(it.orderAt).isSame(today, 'day') && !isFoodspot;
			});
			const statusCount = orders.reduce((acc, obj) => {
				if (obj.status) {
					acc[obj?.status] = (acc[obj?.status] || 0) + 1;
				}
				return acc;
			}, {});

			console.log('statusCount', statusCount);

			this.filtersChips = this.filtersChips.map(chip => {
				chip.selected = status == chip.status;
				if (!chip.status) {
					chip.quantity = orders.filter(
						it =>
							it.status !== OrderStatus.DONE && it.status !== OrderStatus.FAILED
					).length;
				}
				if (chip.status) {
					chip.quantity =
						statusCount[chip.status] !== undefined
							? statusCount[chip.status]
							: 0;
				}
				return chip;
			});

			return of(this.filtersChips);
		})
	);
	constructor(
		private managerFacade: ManagerFacade,
		private navService: NavigationService
	) {}

	ngOnInit() {}

	async onBurgerClick() {
		// await this.navService.adminConsole();
		await this.navService.pinCode();
	}

	async navigateBack() {
		if (this.listenShowBack) {
			this.backEvent.emit();
			return;
		}
		this.navService.managerPage();
	}

	getColor(status: string) {
		let defaultColor = '#B0063E';
		switch (status) {
			case OrderStatus.DONE:
				defaultColor = '#A9A9A9';
				break;
			case OrderStatus.READY:
				defaultColor = '#34A853';
				break;
			case OrderStatus.IN_PREPARATION:
				defaultColor = '#FD5E00';
				break;
			default:
				break;
		}
		return defaultColor;
	}
	selectItem(chip: OrderStatus | null) {
		this.managerFacade.setFilterOrderStatus(chip);
	}
	back() {
		this.navService.managerPage();
	}
}
